import PropTypes from 'prop-types';
import MLink from '@material-ui/core/Link';
import config from '../config';

const CalendarLinks = ({ path }) => {
  return (
    <ul>
      <li>
        <MLink
          href={`https://www.google.com/calendar/render?cid=${encodeURIComponent(`webcal://${config().universal.primaryDomain}${path}`)}`}
        >
          Subscribe on Google Calendar (Desktop/iPhone)
        </MLink>
      </li>
      <li>
        <MLink href={`webcal://${config().universal.primaryDomain}${path}`}>
          Subscribe on Google Calendar (Android)
        </MLink>
      </li>
      <li>
        <MLink href={`webcal://${config().universal.primaryDomain}${path}`}>
          Subscribe on iPhone/Mac/Outlook/Other
        </MLink>
      </li>
      <li>
        <MLink href={`${config().universal.baseUri}${path}`}>
          Download Calendar
        </MLink>
      </li>
    </ul>
  );
};

CalendarLinks.propTypes = {
  path: PropTypes.string.isRequired,
};

export default CalendarLinks;
